import { Tabs, Text } from '@chakra-ui/react';
import { GlobalScreenConfigurations } from '@components/cockpit/panels/operatorStationConfiguration/context/GlobalScreenConfigurations';
import {
  OperatorStationConfigurationProvider,
  OperatorStationConfigurationTabEnum,
  useOperatorStationConfigurationContext,
} from '@components/cockpit/panels/operatorStationConfiguration/OperatorStationConfigurationContext';
import { ReactElement } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import CockpitPanelHeader from '../CockpitPanelHeader';
import Panel from '../Panel';
import GlobalScreenConfigurationFormContainer from './context/GlobalScreenConfigurationFormContainer';
import GridLayoutConfiguration from './screen/GridLayoutConfiguration';

const pageComponents: Record<OperatorStationConfigurationTabEnum, ReactElement> = {
  [OperatorStationConfigurationTabEnum.CONTEXT]: <GlobalScreenConfigurationFormContainer />,
  [OperatorStationConfigurationTabEnum.SCREENS]: <GridLayoutConfiguration />,
};

export function OperatorStationConfigurationContent() {
  const { isEditing, editedItem, selectedTab } = useOperatorStationConfigurationContext();
  const { formatMessage } = useIntl();
  return (
    <Panel
      header={<CockpitPanelHeader label={formatMessage({ id: 'components.sidebar.OPERATOR_STATION_CONFIGURATION' })} />}
    >
      {isEditing && editedItem ? (
        pageComponents[editedItem.tab]
      ) : (
        <Tabs.Root defaultValue={selectedTab} lazyMount variant="light" userSelect="none">
          <Tabs.List>
            <Tabs.Trigger value={OperatorStationConfigurationTabEnum.CONTEXT}>
              <Text>
                <FormattedMessage id="screenConfiguration.title" />
              </Text>
            </Tabs.Trigger>
            <Tabs.Trigger value={OperatorStationConfigurationTabEnum.SCREENS}>
              <Text>
                <FormattedMessage id="grid.title" />
              </Text>
            </Tabs.Trigger>
          </Tabs.List>

          <Tabs.ContentGroup>
            <Tabs.Content value={OperatorStationConfigurationTabEnum.CONTEXT}>
              <GlobalScreenConfigurations />
            </Tabs.Content>
            <Tabs.Content value={OperatorStationConfigurationTabEnum.SCREENS}>
              <GridLayoutConfiguration />
            </Tabs.Content>
          </Tabs.ContentGroup>
        </Tabs.Root>
      )}
    </Panel>
  );
}

export default function OperatorStationConfiguration() {
  return (
    <OperatorStationConfigurationProvider>
      <OperatorStationConfigurationContent />
    </OperatorStationConfigurationProvider>
  );
}
